import { render, staticRenderFns } from "./programsBox.vue?vue&type=template&id=98b30310&scoped=true"
import script from "./programsBox.vue?vue&type=script&lang=js"
export * from "./programsBox.vue?vue&type=script&lang=js"
import style0 from "./programsBox.vue?vue&type=style&index=0&id=98b30310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b30310",
  null
  
)

export default component.exports